import FormattedMessage from 'I18n/components/FormattedMessage';
import { WORKFLOWS_CONVERSION_REPORTING } from 'automation-ui-canvas/constants/Scopes';
import EnrollmentConversionToggleInfo from 'automation-ui-canvas/containers/enrollment-conversion/panel/EnrollmentConversionToggleInfo';
import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import { useQuery } from 'data-fetching-client';
import { Flex } from 'foundations-components/components/Flex';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCallback, useEffect, useState } from 'react';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { FETCH_ENROLLMENT_CONVERSION_STATUS } from 'automation-ui-canvas/containers/enrollment-conversion/wireGetEnrollmentConversionTrackingStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DisableMetricsModal = ({
  onConfirm,
  onCancel
}) => {
  return /*#__PURE__*/_jsx(ConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.metricsToggleSetting.disableMetricsModal.title"
    }),
    use: "danger",
    confirmUse: "danger",
    description: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.metricsToggleSetting.disableMetricsModal.description_1"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.metricsToggleSetting.disableMetricsModal.description_2"
        })
      })]
    }),
    size: "auto",
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.metricsToggleSetting.disableMetricsModal.confirmButton"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.metricsToggleSetting.disableMetricsModal.cancelButton"
    }),
    onConfirm: onConfirm,
    onReject: onCancel
  });
};
const MetricsToggleSetting = ({
  flow,
  readOnly,
  settings: {
    metricsToggle
  },
  onChange // scrollTo,
}) => {
  var _metricsToggle$value, _metricsToggleQueryRe, _metricsToggleQueryRe2, _metricsToggleQueryRe3, _metricsToggleQueryRe4, _metricsToggleQueryRe5, _metricsToggleQueryRe6;
  const currentToggleValue = (_metricsToggle$value = metricsToggle === null || metricsToggle === void 0 ? void 0 : metricsToggle.value) !== null && _metricsToggle$value !== void 0 ? _metricsToggle$value : false;
  const [isToggled, setIsToggled] = useState(false);
  const [showDisableMetricsModal, setShowDisableMetricsModal] = useState(false);
  const canViewConversionReporting = useHasScope(WORKFLOWS_CONVERSION_REPORTING);
  const metricsToggleQueryResult = useQuery(FETCH_ENROLLMENT_CONVERSION_STATUS, {
    variables: {
      flowId: flow.flowId
    },
    fetchPolicy: 'network-only'
  });
  useEffect(() => {
    setIsToggled(currentToggleValue);
  }, [currentToggleValue]);
  const {
    openUpgradeModal
  } = useUpgradeModal('enterprise-conversion-reporting');
  const handleChange = useCallback(checked => {
    const updatedMetricsToggle = Object.assign({}, metricsToggle);
    updatedMetricsToggle.value = checked;
    setIsToggled(checked);
    onChange({
      metricsToggle: updatedMetricsToggle
    });
  }, [metricsToggle, onChange]);
  if (metricsToggleQueryResult.loading) {
    return null;
  }
  const {
    flowsEnabledLimit: limit = 0,
    flowsCurrentlyEnabled: enabledCount = 0
  } = (_metricsToggleQueryRe = metricsToggleQueryResult === null || metricsToggleQueryResult === void 0 || (_metricsToggleQueryRe2 = metricsToggleQueryResult.data) === null || _metricsToggleQueryRe2 === void 0 || (_metricsToggleQueryRe2 = _metricsToggleQueryRe2.fetchEnrollmentConversionStatus) === null || _metricsToggleQueryRe2 === void 0 ? void 0 : _metricsToggleQueryRe2.portalEnablementStatistics) !== null && _metricsToggleQueryRe !== void 0 ? _metricsToggleQueryRe : {};
  const isEnablementRecommended = (_metricsToggleQueryRe3 = metricsToggleQueryResult === null || metricsToggleQueryResult === void 0 || (_metricsToggleQueryRe4 = metricsToggleQueryResult.data) === null || _metricsToggleQueryRe4 === void 0 || (_metricsToggleQueryRe4 = _metricsToggleQueryRe4.fetchEnrollmentConversionStatus) === null || _metricsToggleQueryRe4 === void 0 ? void 0 : _metricsToggleQueryRe4.shouldRecommendEnablement) !== null && _metricsToggleQueryRe3 !== void 0 ? _metricsToggleQueryRe3 : false;
  const shouldAllowEnablement = (_metricsToggleQueryRe5 = metricsToggleQueryResult === null || metricsToggleQueryResult === void 0 || (_metricsToggleQueryRe6 = metricsToggleQueryResult.data) === null || _metricsToggleQueryRe6 === void 0 || (_metricsToggleQueryRe6 = _metricsToggleQueryRe6.fetchEnrollmentConversionStatus) === null || _metricsToggleQueryRe6 === void 0 ? void 0 : _metricsToggleQueryRe6.shouldAllowEnablement) !== null && _metricsToggleQueryRe5 !== void 0 ? _metricsToggleQueryRe5 : false;
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.metricsToggleSetting.title"
    }),
    body: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.metricsToggleSetting.help"
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        gap: "300",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "settingsV2.metricsToggleSetting.disabledTooltip"
          }),
          disabled: shouldAllowEnablement || currentToggleValue,
          children: /*#__PURE__*/_jsx(Toggle, {
            checked: isToggled,
            onChange: ({
              target: {
                checked
              }
            }) => {
              if (!canViewConversionReporting) {
                openUpgradeModal();
                return;
              }
              if (!checked) {
                setShowDisableMetricsModal(true);
                return;
              }
              handleChange(checked);
            },
            readOnly: readOnly,
            disabled: !shouldAllowEnablement && !currentToggleValue
          })
        }), !canViewConversionReporting && /*#__PURE__*/_jsx(LockBadge, {})]
      }), /*#__PURE__*/_jsx(EnrollmentConversionToggleInfo, {
        enabledCount: enabledCount,
        limit: limit,
        isEnablementRecommended: isEnablementRecommended
      }), showDisableMetricsModal && /*#__PURE__*/_jsx(DisableMetricsModal, {
        onConfirm: () => {
          handleChange(false);
          setShowDisableMetricsModal(false);
        },
        onCancel: () => setShowDisableMetricsModal(false)
      })]
    })
  });
};
export default MetricsToggleSetting;